"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const InputAdornment_1 = __importDefault(require("@material-ui/core/InputAdornment"));
const styles_1 = require("@material-ui/core/styles");
const themeColors_1 = require("../../theme/themeColors");
const { totangoGray500 } = themeColors_1.themeColors;
const useStyles = (0, styles_1.makeStyles)({
    root: {
        fontSize: '12px',
        lineHeight: '12px',
        color: totangoGray500,
        alignSelf: ({ multiline }) => (multiline ? 'flex-end' : 'center'),
        width: '50px',
    },
});
const doesNotMatchPattern = (text, pattern) => pattern && text && !pattern.test(text);
const isTooLong = (text, shouldCountChars, maxLength) => shouldCountChars && text && text.length > maxLength;
// {shouldCountChars: true, onChange, maxLength, value, multiline}
const useCharCount = ({ shouldCountChars, onChange, maxLength, multiline, value, pattern }) => {
    const [charCount, setCharCount] = (0, react_1.useState)(0);
    const classes = useStyles({ multiline });
    const handleChange = (0, react_1.useCallback)((e) => {
        const newValue = e.target.value;
        if ((isTooLong(newValue, shouldCountChars, maxLength) || doesNotMatchPattern(newValue, pattern))
            && value?.length <= newValue?.length) {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        onChange(e);
    }, [shouldCountChars, maxLength, pattern, value, onChange]);
    (0, react_1.useEffect)(() => {
        setCharCount(value ? value.length : 0);
    }, [value]);
    const component = (0, react_1.useMemo)(() => (react_1.default.createElement(InputAdornment_1.default, { position: "end", classes: classes, disableTypography: true }, `${charCount}/${maxLength}`)), [charCount, classes, maxLength]);
    return { handleChange, component };
};
exports.default = useCharCount;
//# sourceMappingURL=useCharCount.js.map